<template>
  <el-dialog
    id="leaderEngagementDialog"
    width="400px"
    :visible.sync="showLocal"
    :show-close="true"
  >
    <div
      slot="title"
      class="title"
    >
      {{ $t("component.engagementPaused.engagementPausedTitle") }}
    </div>

    <div class="content">
      {{ $t("component.engagementPaused.engagementPausedDescription") }}
    </div>

    <div
      slot="footer"
      style="text-align: center;"
    >
      <el-button
        type="primary"
        round
        @click="showLocal = false"
      >
        {{ $t('common.confirm') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import dialog from '@/mixins/dialog';

export default {
  name: 'LeaderEngagementPaused',

  mixins: [dialog],
};
</script>
